module.exports = __webpack_public_path__ + "img/zbsb.760cf100.png";